angular.module("admin").factory("AdminReportsService", ["$http", "ENV", function ($http, ENV) {

	/**
     * API
     */
	return {
		addEntity: addEntity,
		deleteEntity: deleteEntity,
		editEntity: editEntity,
		getEntity: getEntity,
		getAllEntities: getAllEntities,
	};


	/**
     * Récupérer toutes les entités
     * @returns {*}
     */
	function getAllEntities() {
		return $http.get(ENV.API_URL + "/admin/reports");
	}

	/**
     * Mettre à jour un rapport.
     * @param report
     * @returns {*|HttpPromise}
     */
	function editEntity(report) {
		return $http.put(ENV.API_URL + "/admin/reports/" + report.id, report);
	}


	/**
     * Récupérer une entité par son ID.
     *
     * @param id l'Id d'entité à récupérer.
     * @returns {*}
     */
	function getEntity(id) {
		return $http.get(ENV.API_URL + "/admin/reports/" + id);
	}

	/**
     * Supprimer une entité.
     *
     * @param entity l'entité à supprimer.
     * @returns {HttpPromise|*|{display}}
     */
	function deleteEntity(entityId) {
		return $http.delete(ENV.API_URL + "/admin/reports/" + entityId);
	}


	/**
     * POster un company vers le serveur.
     * @param company
     * @returns {*|HttpPromise}
     */
	function addEntity(entity) {
		return $http.post(ENV.API_URL + "/admin/reports", entity);
	}


}]);
